import { RegistrationRegister, RegisterUnofficial, studentEvaluation } from '../../../helper/constants';
export const updateAccessSelector = ({ access }) => access;

// Find a resolved menu item by name across all access buckets (the level it lands
// in depends on its CamsOrder, so we don't assume one). Returns its menuAccess.
// With moduleOrder, a row of that module wins over a same-named row elsewhere (menu
// names are not unique across modules); any row of the name is the fallback.
const findMenuAccess = (accessRoot, name, moduleOrder) => {
    const root = accessRoot || {};
    const all = [
        ...(root.parentLevel || []),
        ...(root.nestedParentLevel || []),
        ...(root.subNestedParentLevel || []),
        ...(root.subDeepNestedParentLevel || [])
    ];
    const named = all.filter((v) => v && v.menuItemName && v.menuItemName.trim() === name);
    const hit = (moduleOrder !== undefined && named.find((v) => v.moduleorder === moduleOrder)) || named[0];
    return hit ? hit.menuAccess : undefined;
};

// CAMSMenu module order of Registration, as the legacy Student Evaluation and Register checks filter on.
const REGISTRATION_MODULE_ORDER = 2;

// Access levels as CAMSMenu records them: 0 none, 1 read, 2 write.
export const ACCESS_NONE = 0;
export const ACCESS_READ = 1;
export const ACCESS_WRITE = 2;

// A user who simply lacks a grant still gets the row back with menuAccess 0, so `undefined`
// means the menu tree has no such row at all — an Azure-auth user (no cams menu tree) or a
// tenant that has not run the menu migration yet. Both fall back to allow, because the API
// enforces the same rules server-side and a false "no access" would lock out valid users.
const accessLevelOr = (root, name, fallback = ACCESS_WRITE, moduleOrder) => {
    const level = findMenuAccess(root, name, moduleOrder);
    return level === undefined ? fallback : level;
};

/**
 * Student Evaluation (Registration). >= ACCESS_READ opens the page, the audit and the student's
 * degree plan read-only; ACCESS_WRITE allows audit edits.
 */
export const studentEvaluationAccessSelector = ({ access }) =>
    accessLevelOr(access && access.access, studentEvaluation, ACCESS_WRITE, REGISTRATION_MODULE_ORDER);

/**
 * Degree Planning-Plans (Degree Planning). ACCESS_WRITE lets the Student Evaluation Planner tab
 * change the plan: edits, review decisions, comments, make active, create, copy, archive and
 * restore. The tab also needs the degree_planning_module flag; the gateway enforces the right.
 */
export const degreePlanningPlansAccessSelector = ({ access }) =>
    accessLevelOr(access && access.access, 'Degree Planning-Plans');

/**
 * Base Data Dictionary access ('Data Dictionary'). Gates the header icon, the menu item and
 * the page itself. >= ACCESS_READ means the user may open the dictionary at all.
 */
export const dataDictionaryAccessSelector = ({ access }) =>
    accessLevelOr(access.access, 'Data Dictionary');

/**
 * Curation access ('Data Dictionary Management'). >= ACCESS_READ reveals the Curate tab
 * read-only; ACCESS_WRITE additionally allows the mutating actions there. A user with base
 * access but no management grant never sees Curate.
 */
export const dataDictionaryManagementSelector = ({ access }) =>
    accessLevelOr(access.access, 'Data Dictionary Management');

export const registrationRegisterSelector = ({ access }) => {
  
    let RegistrationRegisterAccess = access.access.subNestedParentLevel.filter((v, i) =>
             v.menuItemName.trim() === RegistrationRegister && v.moduleorder === 2
           )
          
           return (RegistrationRegisterAccess.length > 0) ? RegistrationRegisterAccess[0].menuAccess : 2;
     
}

export const unofficialRegisterSelector = ({ access }) => {
  
    let RegistrationRegisterAccess = access.access.subNestedParentLevel.filter((v, i) =>
             v.menuItemName.trim() === RegisterUnofficial && v.moduleorder === 2
           )

          
           return (RegistrationRegisterAccess.length > 0) ? RegistrationRegisterAccess[0].menuAccess : 2;
     
}
